import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=5347df70&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=js"
export * from "./promotion.vue?vue&type=script&lang=js"
import style0 from "./promotion.vue?vue&type=style&index=0&id=5347df70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347df70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5347df70')) {
      api.createRecord('5347df70', component.options)
    } else {
      api.reload('5347df70', component.options)
    }
    module.hot.accept("./promotion.vue?vue&type=template&id=5347df70&scoped=true", function () {
      api.rerender('5347df70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/training/promotion.vue"
export default component.exports